var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-title"},[_c('div',{staticClass:"left"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }